import React, { useEffect, useState } from 'react';

import './IntroOverlay.css';

const FADE_MS = 650;
const MAX_WAIT_MS = 12000;

function IntroOverlay({ ready, onComplete }) {
  const [reducedMotion] = useState(
    () => window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches || false,
  );
  const [videoSource] = useState(() =>
    window.matchMedia?.('(max-width: 767px)')?.matches
      ? '/videos/glace-intro-mobile.mp4'
      : '/videos/glace-intro-desktop.mp4',
  );
  const [videoFinished, setVideoFinished] = useState(reducedMotion);
  const [waitExpired, setWaitExpired] = useState(false);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const timeout = window.setTimeout(() => setWaitExpired(true), MAX_WAIT_MS);
    return () => window.clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (videoFinished && ready) setFading(true);
    if (waitExpired) setFading(true);
  }, [ready, videoFinished, waitExpired]);

  useEffect(() => {
    if (!fading) return undefined;
    const timeout = window.setTimeout(onComplete, reducedMotion ? 0 : FADE_MS);
    return () => window.clearTimeout(timeout);
  }, [fading, onComplete, reducedMotion]);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previousOverflow; };
  }, []);

  return (
    <div className={`intro-overlay${fading ? ' intro-overlay--fading' : ''}`} role="status" aria-label="Carregando Glacê">
      {!reducedMotion && (
        <video
          className="intro-overlay__video"
          src={videoSource}
          autoPlay
          muted
          playsInline
          preload="auto"
          aria-hidden="true"
          onEnded={() => setVideoFinished(true)}
          onError={() => setVideoFinished(true)}
        />
      )}
      {videoFinished && !ready && !fading && (
        <span className="intro-overlay__loading">Carregando cardápio…</span>
      )}
    </div>
  );
}

export default IntroOverlay;
